<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <TableTeaser  :teasers="teasers" :is_admin="true" />

      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/SideBar/SideBar";
import TableTeaser from "@/components/Tables/Teaser";
import TeaserService from "@/services/TeaserService";

export default {
  data() {
    return {
      teasers: {}
    };
  },
  components: {
    sidebar: sidebar,
    TableTeaser: TableTeaser
  },
  created() {
    TeaserService.Index().then(result => {
      this.teasers = result.data;
    });
  },
};
</script>